/**
 * Constants for Configuration actions.
 * URL in these constants are having dynamic variables
 * wrapped in {}, replace them with original dynamic variables
 * in order to send API requests.
 */

export const CONFIGURATION_TYPES_MAPPING = {
  186: {
    identifier: "achievementClubRequestDtoList",
    type: "CONFIG_ACHIEVMENT_CLUB",
    url: "achievement/allAchievement",
    defineLine: false,
  },
  532: {
    identifier: "whatsAppConfigRequestDTOList",
    type: "CONFIG_WHATSAAP",
    url: "configuration/whatsApp/schemeCommunicationList",
    defineLine: false,
  },
  533: {
    identifier: "payoutMailerEmailUserRequestDTOS",
    type: "MX_PAYOUT_MAILER",
    url: "configuration/payout/mailer/users",
    defineLine: false,
  },
  187: {
    identifier: "budgetCategoryRequestDtoList",
    type: "CONFIG_BUDGET_CATEGORY",
    url: "budgetCategory/getBudgetCategory",
    defineLine: false,
  },
  190: {
    identifier: "globalHeaderFooterRequestDtoList",
    type: "CONFIG_GLOBAL_HEADER_FOOTER",
    url: "headerfooter/allHeaderFooter",
    defineLine: true,
  },
  191: {
    identifier: "proDataRequestDtoList",
    type: "CONFIG_PRO_DATA_SETUP",
    url: "prodata/allProData",
    defineLine: false,
  },
  192: {
    identifier: "provisionSetupRequestDtoList",
    type: "CONFIG_PROVISION_SETUP",
    url: "provision/allProvisionSetup",
    defineLine: false,
  },
  194: {
    identifier: "revisionSchemeRemarkDtoList",
    type: "CONFIG_SCHEME_REMARKS",
    url: "revisionSchemeRemarks/allRevisionSchemeRemarks",
    defineLine: false,
  },
  195: {
    identifier: "configStockRequestDtoList",
    type: "CONFIG_STOCK_TYPE",
    url: "configStock/allConfigStock",
    defineLine: false,
  },
  341: {
    identifier: "rrfTotPartnerSchemeCodeRequestDtoList",
    type: "RRF_TOT_TYPE",
    url: "achievement/allRrfTotConfigData",
    defineLine: false,
  },
  352: {
    identifier: "daysCheckDTOList",
    type: "DAYS_CHECK",
    url: "daysCheckDTOList",
    defineLine: false,
  },
  353: {
    identifier: "branchUserRequestDTOList",
    type: "BRANCH_SETUP",
    url: "configuration/config/branch/allusers",
    defineLine: false,
  },
  387: {
    identifier: "configurationSetupDTO",
    type: "COMMUNICATION_SALES_GROUP",
    url: "configuration/configurationData",
    defineLine: false,
  },
  388: {
    identifier: "configurationSetupDTO",
    type: "PAYOUT_HO_GROUP",
    url: "configuration/defaultHoGroupList",
    defineLine: false,
  },
  494: {
    identifier: "configurationSetupDTO",
    type: "PAYOUT_COMMUNICATION_HO_GROUP",
    url: "configuration/defaultHoGroupList",
    defineLine: false,
  },
  389: {
    identifier: "configurationSetupDTO",
    type: "PAYOUT_SENDER",
    url: "configuration/senderPayoutList",
    defineLine: false,
  },
  445: {
    identifier: "configurationSetupDTO",
    type: "SCHEME_COMMUNICATION_SALES",
    url: "configuration/configurationData",
    defineLine: false,
  },
};
export const CONFIGURATION_POST_PAYLOAD = {
  tableIdentifier: "",
  achievementClubRequestDtoList: [
    {
      id: 0,
      configMstId: 0,
      parentSoldTo: 0,
      childSoldTo: 0,
      effectiveFrom: "",
      effectiveTo: "",
      recordStatusLookupId: 0,
    },
  ],
  proDataRequestDtoList: [
    {
      configMstId: 0,
      id: 0,
      minValue: 0,
      maxValue: 0,
      payoutPercent: 0,
      recordStatusLookupId: 0,
    },
  ],
  revisionSchemeRemarkDtoList: [
    {
      id: 0,
      division: "",
      schemeRevisionName: "",
      sortName: "",
      recordStatusLookupId: 0,
      configMstId: 0,
    },
  ],
  globalHeaderFooterRequestDtoList: [
    {
      id: 0,
      globalHeaderFooterId: 0,
      globalHeaderFooterName: "",
      recordStatusLookupId: "",
      incentiveAudienceLookupId: "",
      configMstId: 0,
    },
  ],
  configStockRequestDtoList: [
    {
      configMstId: 0,
      id: 0,
      division: 0,
      channel: 0,
      payoutId: 0,
      recordStatusLookupId: 0,
      stockType: 0,
      orderDimKey: 0,
    },
  ],
  budgetCategoryRequestDtoList: [
    {
      budgetCategoryId: 0,
      divisionId: 0,
      recordStatusLookupId: 0,
      budgetName: "",
      shortDescription: "",
      businessUnit: "",
      configMstId: 0,
    },
  ],
  budgetSubCategoryRequestDtoList: [
    {
      id: 0,
      budgetCategoryId: 0,
      recordStatusLookupId: 0,
      name: "",
      description: "",
    },
  ],
  provisionSetupRequestDtoList: [
    {
      id: 0,
      planStatusId: 0,
      recordStatusLookupId: 0,
      configMstId: 0,
    },
  ],
  rrfTotConfigDataDtoList: [
    {
      id: 0,
      partnerCode: "",
      partnerName: "",
      schemeName: "",
      schemeCode: "",
      configMstId: 0,
      status: 0,
    },
  ],
  daysCheckDTOList: [
    {
      id: 0,
      daysCheckName: "",
      noOfDays: "",
      status: 0,
      configMstId: 0,
    },
  ],
  branchUserRequestDTOList: [
    {
      id: 0,
      configMstId: 0,
      userDimKey: "",
      branchDimKey: 0,
    },
  ],
  whatsAppConfigRequestDTOList: [
    {
      id: 0,
      configMstId: 0,
      recordStatusLookupId: 0,
    },
  ],
  payoutMailerEmailUserRequestDTOS: [
    {
      id: 0,
      configMstId: 0,
    },
  ],
  configurationSetupDTO: [
    {
      id: 0,
      configMstId: 0,
    },
  ],
  whatsAppRoleConfigRequestDTOList: [
    {
      configMstId: 0,
      id: 0,
    },
  ],
};
export const CONFIG_STATUSES = [
  { value: 2, text: "Active" },
  { value: 3, text: "Inactive" },
];
export const CONFIG_STATUSES_ROLE = [
  { value: true, text: "Active" },
  { value: false, text: "Inactive" },
];
export const CONFIGURATION_TYPES_LIST =
  "/scheme-planning/ims/configuration/allCategory?division={divisionId}&incentiveAudience={audience}&channelIds={channelIds}";
export const GET_CONFIGURATION_GRID =
  "/scheme-planning/ims/{journalTypeUrl}?configMstId={configId}";
export const CREATE_CONFIGURATION_DATA =
  "/scheme-planning/ims/configuration/create";
export const CREATE_RRF_TOT_CONFIGURATION_DATA =
  "/scheme-planning/ims/configuration/create?division={division}&channels={channels}";
export const DELETE_CONFIGURATION_DATA =
  "/scheme-planning/ims/configuration/deleteList";
export const ACHIEVEMENT_CLUBBING_EXPORT =
  "/scheme-planning/ims/achievement/download/?configMstId={configId}";
export const ACHIEVEMENT_CLUBBING_IMPORT =
  "/scheme-planning/ims/achievement/upload/?configMstId={configId}";
export const GET_SUB_CATEGORY_LIST =
  "/scheme-planning/ims/budgetCategory/getBudgetSubCategory?budgetId={budgetId}";
export const GET_WHATAPP_CONFIG_LIST =
  "/scheme-planning/ims/configuration/whatsApp/roleConfigList?configMstId={configMstId}";
export const CREATE_CONFIG_HEADER_FOOTER =
  "/scheme-planning/ims/headerfooter/createDetails";
export const GET_CONFIGURATION_DAYS_CHECK_GRID =
  "/scheme-planning/ims/configuration/getConfigList?tableIdentifier={journalTypeUrl}&configMstId={configId}";
export const GET_ALL_BRANCH_OPTIONS_URL =
  "/scheme-planning/ims/configuration/config/branch/branches?configMstId={configId}";
export const USER_NAME_SMART_SEARCH_CODE_URL =
  "/scheme-planning/ims/configuration/config/branch/user?userCode={userId}";
export const CONFI_JOB_ROLE_SMART_SEARCH_CODE_URL =
  "/scheme-planning/ims/configuration/payout/mailer/jobroles?configMstId={configMstId}&searchKey={searchKey}";
export const CREATE_COMMUNICATION_SALES_CONFIGURATION_DATA =
  "/scheme-planning/ims/configuration/create?division={division}&channels={channel}";
export const GET_PURPOSE_LIST =
  "/scheme-planning/ims/configuration/purpose?channel={channel}";
export const GET_JOB_LIST =
  "/scheme-planning/ims/configuration/job?hrchyId={hrchyId}";
export const GET_GROUP_TYPE_LIST =
  "/scheme-planning/ims/configuration/salesGroupType?hrchyId={hrchyId}";
export const GET_HO_GROUP_LISTS =
  "/scheme-planning/ims/configuration/schemeMailingGroup?division={division}";
export const REGION_CONFIGURATION =
  "/scheme-planning/ims/configuration/payout/mailer/regions?configMstId={configMstId}";
export const GET_EMAIL_ID_LIST =
  "/scheme-planning/ims/configuration/configPaySender?emailId={emailId}";
export const DOWNLOAD_CONFIGURATION_PAYOUT_SENDER =
  "/scheme-planning/ims/configuration/payout/mailer/export?configMstId={configMstId}";
export const UPLOAD_CONFIGURATION_PAYOUT_SENDER =
  "/scheme-planning/ims/configuration/payout/mailer/import";
